import { render, staticRenderFns } from "./WorkStoppage.vue?vue&type=template&id=7b0960d6&"
import script from "./WorkStoppage.vue?vue&type=script&lang=js&"
export * from "./WorkStoppage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports